import { defineComponent } from 'vue'
import { Dataset } from '~/types/reportTypes'
import ReportMixin from './reportMixin'

/**
 * Mixin for code health trend report utilities
 */
export default defineComponent({
  name: 'CodeHealthReportMixin',

  mixins: [ReportMixin],

  computed: {
    emptyCodeHealthChartDataSet(): Dataset[] {
      return [
        { name: 'ACTIVE ISSUES', chartType: 'bar', values: [17, 19, 12, 9, 14, 5, 5, 4] },
        { name: 'RESOLVED ISSUES', chartType: 'bar', values: [-17, -15, -19, -11, -12, 0, -4, -2] }
      ]
    }
  }
})
